import { takeEvery, put } from 'redux-saga/effects';

import signUpActions from '../actionTypes/signUpActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { SIGNUP_URL } from '../routes';

function* signUp({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: SIGNUP_URL,
      method: 'POST',
      data: payload
    },
    successAction: signUpActions.userSignUpSuccess,
    failureAction: signUpActions.userSignUpFailed
  });
}

export default function* watchUserSignUp() {
  yield takeEvery(signUpActions.userSignUp, signUp);
}
